export const DISPLAY_ON_WIDGET_SELECTOR = 'widget_selector';
export const CLOSE_BUTTON_TRIGGER_ID = 'close-button';
export const DIALOG_BACKGROUND_TRIGGER_ID = 'dialog-background';
